import React from 'react';
import './StepDescription.scss';

export interface StepDescriptionProps {
  order: string | number;
  description: string;
}

const StepDescription = ({ order, description }: StepDescriptionProps) => {
  return (
    <div className="stats-step-description">
      <span className="stats-step-description__order"> {order}. </span>
      <span className="stats-step-description__description"> {description} </span>
    </div>
  );
};

export default StepDescription;
